export const setPageToDisplay = pageToDisplay => {
  return {
    type: 'SET_PAGE_TO_DISPLAY',
    pageToDisplay
  }
}